<script>
    import FindUser from "./FindUser.svelte";
    import UserView from "./UserView.svelte";
    

</script>

<br >

<FindUser />

<UserView />




<!-- <FindClan /> -->
<!-- <ShowClan /> -->